import { Button, createStyles, Group } from '@mantine/core';
import React from 'react';

import { PublishButton } from './PublishButton';
import { SaveDraftButton } from './SaveDraftButton';
import { useStoreListingWizard } from '../hooks';
import { OnCloseCallback, StepId } from '../types';

interface WizardFooterProps {
  onClose: OnCloseCallback;
}

export function WizardFooter({ onClose }: WizardFooterProps) {
  const { classes } = useStyles();
  const {
    contextData,
    currentStep,
    onPrev,
    onNext,
    isNextDisabled,
    isFinalStep,
  } = useStoreListingWizard();

  const isEdit = contextData.intent === 'edit';
  const isPublishedStoreListing =
    contextData.storeListing?.status === 'published';

  const onPrevHandler = () => {
    if (currentStep.id === StepId.ChooseProduct) {
      onClose({ confirmBeforeClose: true });
      return;
    }

    onPrev();
  };

  // Edit mode
  if (isEdit) {
    return (
      <footer className={classes.footer}>
        <Group position="right">
          <Button
            variant={isPublishedStoreListing ? 'default' : 'white'}
            color={isPublishedStoreListing ? undefined : 'dark'}
            onClick={() => onClose({ confirmBeforeClose: true })}
          >
            Cancel
          </Button>

          {!isPublishedStoreListing ? (
            <SaveDraftButton onClose={onClose} />
          ) : null}

          <PublishButton onClose={onClose} />
        </Group>
      </footer>
    );
  }

  // Create mode
  return (
    <footer className={classes.footer}>
      <Group position="apart">
        <Button variant="default" onClick={onPrevHandler}>
          {currentStep.id === StepId.ChooseProduct ? 'Cancel' : 'Back'}
        </Button>

        {isFinalStep ? (
          <Group>
            <SaveDraftButton onClose={onClose} />
            <PublishButton onClose={onClose} />
          </Group>
        ) : (
          <Button
            onClick={onNext}
            disabled={isNextDisabled}
            data-testid="modal-continue-btn"
          >
            Continue
          </Button>
        )}
      </Group>
    </footer>
  );
}

const useStyles = createStyles((theme) => ({
  footer: {
    paddingInline: theme.spacing.xl,
    paddingBlock: theme.spacing.lg,
    borderTop: `1px solid ${theme.colors.gray[2]}`,
  },
}));
